<template>
  <div id="articulos">
    <div>
      <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
      <v-row align-center justify-center>
        <v-col xs="12">
          <base-material-card
            color="primary"
            icon="mdi-dolly"
            title="Administrar Productos"
            class="elevation-1 px-5 py-3"
          >
            <v-card-actions>
              <v-spacer />
              <v-btn
                fab
                dark
                x-small
                color="primary"
                slot="activator"
                @click.native="agregar"
                title="Agregar Registro"
                v-tippy
              >
                <v-icon dark>add</v-icon>
              </v-btn>
            </v-card-actions>
            <v-card-text>
              <div id="datagrid">
                <v-client-table
                  ref="vuetable"
                  :data="items"
                  :columns="columns"
                  :options="options"
                  class="elevation-2 pa-2"
                >
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info"
                      >No se encontro ningun registro</v-alert
                    >
                  </template>

                  <template slot="actions" slot-scope="props">
                    <v-btn
                      x-small
                      fab
                      dark
                      color="success"
                      @click.native="editar(props.row.uuid)"
                      title="Editar"
                      v-tippy
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      x-small
                      fab
                      dark
                      color="pink"
                      @click.native="eliminar(props.row.uuid)"
                      title="Eliminar"
                      v-tippy
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                </v-client-table>
              </div>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="modal" max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline">{{ tituloModal }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-card>
                <v-card-text>
                  <v-radio-group v-model="model.tipo_producto" row>
                    <v-radio
                      label="Producto o Servicio"
                      value="Concepto"
                      @change="limpiar_listas()"
                    ></v-radio>
                    <v-radio
                      label="Mercancia"
                      value="Mercancia"
                      @change="limpiar_listas()"
                    ></v-radio>
                  </v-radio-group>
                  <v-row>
                    <v-col cols="12" md="4" sm="12">
                      <v-text-field
                        v-model="model.clave"
                        label="No. Identificación"
                        :rules="[this.$rules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8" sm="12">
                      <v-text-field
                        v-model="model.nombre"
                        label="Nombre"
                        :rules="[this.$rules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="8" sm="8">
                      <v-text-field
                        v-model="model.descripcion"
                        label="Descripcion"
                        :rules="[this.$rules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4">
                      <v-text-field
                        v-model="model.iva"
                        label="Porcentaje de IVA"
                        :rules="[this.$rules.required, this.$rules.decimal]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="6" sm="6">
                      <v-text-field
                        v-model="model.precio_venta"
                        label="Precio de Venta"
                        :rules="[this.$rules.required, this.$rules.decimal]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" md="6" sm="6">
                      <v-autocomplete
                        v-model="model.objetoImp"
                        label="Objeto Imp"
                        :rules="[this.$rules.required]"
                        :items="objetosImp"
                        :hide-no-data="true"
                        item-text="text"
                        item-value="id"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="6" sm="6">
                      <v-autocomplete
                        v-model="model.clave_sat"
                        :items="clavessat"
                        :hide-no-data="true"
                        :loading="loadClave"
                        ref="selectproducto"
                        :search-input.sync="search_claves"
                        placeholder="Ingrese nombre de producto para buscar"
                        prepend-icon="search"
                        clearable
                        :item-text="getNombreProducto"
                        item-value="clave"
                        :rules="[this.$rules.required]"
                        label="Clave Producto o Servicio"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6" md="6" sm="6">
                      <v-autocomplete
                        v-model="model.unidad_sat"
                        :items="unidadessat"
                        :hide-no-data="true"
                        :loading="loadUnidad"
                        ref="selectunidad"
                        :search-input.sync="search_unidades"
                        placeholder="Ingrese nombre de unidad para buscar"
                        prepend-icon="search"
                        clearable
                        :item-text="getNombreUnidad"
                        item-value="clave"
                        :rules="[this.$rules.required]"
                        label="Unidad Medida"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="10" md="10" sm="10">
                      <v-autocomplete
                        v-model="model.embalaje"
                        :items="embalaje_sat"
                        :hide-no-data="true"
                        :loading="loadEmbalaje"
                        ref="selectembalaje"
                        :search-input.sync="search_embalajes"
                        placeholder="Ingrese nombre de embalaje para buscar"
                        prepend-icon="search"
                        clearable
                        :item-text="getNombrePELIGROSO"
                        item-value="clave"
                        label="Embalaje"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="2" md="2" sm="2">
                      <v-text-field
                        v-model="model.pesokg"
                        label="PesoKG"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" md="2" sm="2">
                      <v-autocomplete
                        v-model="model.material_peligroso"
                        label="Material Peligroso"
                        :rules="[this.$rules.required]"
                        :items="material"
                        :hide-no-data="true"
                        item-text="text"
                        item-value="id"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="10" md="10" sm="10">
                      <v-autocomplete
                        v-if="model.material_peligroso == 'Sí'"
                        v-model="model.clave_material_peligroso"
                        :items="material_sat"
                        :hide-no-data="true"
                        :loading="loadMaterial"
                        ref="selectmaterial"
                        :search-input.sync="search_materiales"
                        placeholder="Ingrese nombre de material para buscar"
                        prepend-icon="search"
                        clearable
                        :item-text="getNombrePELIGROSO"
                        item-value="clave"
                        :rules="[this.$rules.required]"
                        label="Clave Material Peligroso"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="model.tipo_producto == 'Concepto'">
                    <v-col cols="2" md="2" sm="2">
                      <v-autocomplete
                        v-model="model.hidrocarburos"
                        label="Hidrocarburos"
                        :items="hidrocarburo"
                        :hide-no-data="true"
                        item-text="text"
                        item-value="id"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="3" md="3" sm="3" v-if="model.hidrocarburos == 'S\u00ed'">
                      <v-autocomplete
                        v-model="model.tipo_permiso"
                        label="TipoPermiso"
                        :items="TipoPermiso"
                        :hide-no-data="true"
                        :item-text="(item) => item.clave + ' - ' + item.descripcion"
                        item-value="clave"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="3" md="3" sm="3" v-if="model.hidrocarburos == 'S\u00ed'">
                      <v-autocomplete
                        v-model="model.sub_producto_hyp"
                        label="SubProductoHYP"
                        :items="SubProductoHYP"
                        :hide-no-data="true"
                        :item-text="(item) => item.clave + ' - ' + item.descripcion"
                        item-value="clave"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="4" md="4" sm="4" v-if="model.hidrocarburos == 'S\u00ed'">
                      <v-text-field
                        v-model="model.numero_permiso"
                        label="NumeroPermiso"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" small @click="modal = false">
            <v-icon small>mdi-cancel</v-icon> Cancelar
          </v-btn>
          <v-btn color="success" small @click="guardar">
            <v-icon small>mdi-check-circle-outline</v-icon> Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  created: function () {
    this.URL = this.$hostname + "carta_porte/catalogos/";
    this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";
    this.model = this.clean_model();

    this.cargar();
    //this.cargar_empresa();
  },
  computed: {
    tituloModal() {
      return this.updateModel === false ? "Nuevo Producto" : "Editar Producto";
    },
  },
  data: () => ({
    URL_SAT: "",
    URL: "",
    search_claves: "",
    search_unidades: "",
    search_materiales: "",
    search_embalajes: "",
    isLoading: false,
    loadClave: false,
    loadUnidad: false,
    loadMaterial: false,
    loadEmbalaje: false,
    tabla: "productos",
    clavessat: [],
    unidadessat: [],
    embalaje_sat: [],
    material_sat: [],
    modal: false,
    material: [
      {
        id: "Sí",
        text: "Sí",
      },
      {
        id: "No",
        text: "No",
      },
    ],
    hidrocarburo: [
      {
        id: "Sí",
        text: "Sí",
      },
      {
        id: "No",
        text: "No",
      },
    ],
     TipoPermiso: [
      {
        clave: "PER01",
        descripcion: "Expendio al público de petrolíferos"
      },
      {
        clave: "PER02",
        descripcion: "Distribución de petrolíferos"
      }
    ],
    SubProductoHYP: [
    {
      clave: "SP16",
      descripcion: "Gasolina regular"
    },
    {
      clave: "SP17",
      descripcion: "Gasolina premium"
    },
    {
      clave: "SP18",
      descripcion: "Diésel automotriz"
    }
  ],
    objetosImp: [
      {
        id: "01",
        text: "01-No objeto de impuesto",
      },
      {
        id: "02",
        text: "02-Sí objeto de impuesto",
      },
      {
        id: "03",
        text: "03-Sí objeto del impuesto y no obligado al desglose",
      },
    ],
    breadcrumbs: [
      {
        text: "Inicio",
        disabled: false,
        to: "/home",
      },
      {
        text: "Productos",
        disabled: true,
        href: "",
      },
    ],

    model: {},
    updateModel: false,
    columns: [
      "clave",
      "nombre",
      "tipo_producto",
      "clave_sat",
      "unidad_sat",
      "precio_venta",
      "actions",
    ],
    options: {
      filterable: true,
      headings: {
        clave: "No. Identificación",
        nombre: "Nombre",
        tipo_producto: "Tipo",
        clave_sat: "Clave SAT",
        unidad_sat: "Unidad SAT",
        precio_venta: "Precio de Venta",
        actions: "Operaciones",
      },
    },
    items: [],
    search: "",
    empresa: null,
    imagenes: [],
  }),
  watch: {
    search_claves(val) {
      //Si no ha escrito 3 letras o mas
      if (val == null || val.length < 3) return false;
      // Si todavía esta buscando
      if (this.loadClave) return false;

      this.search_claves_function(val);
    },
    search_unidades(val) {
      //Si no ha escrito 3 letras o mas
      if (val == null || val.length < 1) return false;
      // Si todavía esta buscando
      if (this.loadUnidad) return false;

      this.search_unidades_function(val);
    },
    search_materiales(val) {
      if (val == null || val.length < 1) return false;
      if (this.loadMaterial) return false;
      this.search_materiales_function(val);
    },
    search_embalajes(val) {
      if (val == null || val.length < 1) return false;
      if (this.loadEmbalaje) return false;
      this.search_embalajes_function(val);
    },
  }, //watch
  methods: {
    getNombreProducto(row) {
      var self = this;

      return row.clave + " - " + row.descripcion;
    },
    getNombrePELIGROSO(row) {
      return row.clave + " - " + row.descripcion;
    },
    limpiar_listas() {
      this.clavessat = [];
      this.unidadessat = [];
      this.model.clave_sat = "";
      this.model.unidad_sat = "";
    },
    getNombreUnidad(row) {
      var self = this;

      return row.clave + " - " + row.nombre;
    },
    search_claves_function(val) {
      var self = this;
      self.loadClave = true;

      var url = this.URL_SAT + "list_producto_servicio_carta_porte/";
      if (self.model.tipo_producto == "Concepto") {
        url = this.URL_SAT + "list_producto_servicio/";
      }

      var params = {
        filtros: {
          $or: [
            {
              descripcion: {
                $regex: val,
                $options: "i",
              },
            },
            {
              clave: {
                $regex: val,
                $options: "i",
              },
            },
          ],
        },
      };

      this.$axios
        .post(url, params)
        .then((res) => {
          if (typeof res.data !== "undefined" && res.data.length > 0) {
            self.clavessat = res.data.sort(function (a, b) {
              if (a.clave > b.clave) return 1;
              if (a.clave < b.clave) return -1;
              return 0;
            });
          }
        })
        .catch((err) => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al buscar los productos sat.",
            footer: "",
          });
          console.log(err);
        })
        .then(() => {
          self.loadClave = false;
        });
    },
    search_unidades_function(val) {
      var self = this;
      self.loadUnidad = true;
      var url = this.URL_SAT + "list_unidades_peso/";

      if (self.model.tipo_producto == "Concepto") {
        url = this.URL_SAT + "list_unidades_medida/";
      }

      var params = {
        filtros: {
          $or: [
            {
              nombre: {
                $regex: val,
                $options: "i",
              },
            },
            {
              clave: {
                $regex: val,
                $options: "i",
              },
            },
          ],
        },
      };

      this.$axios
        .post(url, params)
        .then((res) => {
          if (typeof res.data !== "undefined" && res.data.length > 0) {
            self.unidadessat = res.data.sort(function (a, b) {
              if (a.clave > b.clave) return 1;
              if (a.clave < b.clave) return -1;
              return 0;
            });
          }
        })
        .catch((err) => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al buscar las unidades sat.",
            footer: "",
          });
          console.log(err);
        })
        .then(() => {
          self.loadUnidad = false;
        });
    },
    search_materiales_function(val) {
      var self = this;
      self.loadMaterial = true;

      var params = {
        filtros: {
          $or: [
            {
              descripcion: {
                $regex: val,
                $options: "i",
              },
            },
            {
              clave: {
                $regex: val,
                $options: "i",
              },
            },
          ],
        },
      };

      this.$axios
        .post(this.URL_SAT + "list_material_peligroso/", params)
        .then((res) => {
          if (typeof res.data !== "undefined" && res.data.length > 0) {
            self.material_sat = res.data.sort(function (a, b) {
              if (a.clave > b.clave) return 1;
              if (a.clave < b.clave) return -1;
              return 0;
            });
          }
        })
        .catch((err) => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al buscar materiales sat.",
            footer: "",
          });
          console.log(err);
        })
        .then(() => {
          self.loadMaterial = false;
        });
    },
    search_embalajes_function(val, lastKey = null) {
      var self = this;
      self.loadEmbalaje = true;

      var params = {
        filtros: {
          $or: [
            {
              descripcion: {
                $regex: val,
                $options: "i",
              },
            },
            {
              clave: {
                $regex: val,
                $options: "i",
              },
            },
          ],
        },
      };

      this.$axios
        .post(this.URL_SAT + "list_tipo_embalaje/", params)
        .then((res) => {
          if (typeof res.data !== "undefined" && res.data.length > 0) {
            self.embalaje_sat = res.data.sort(function (a, b) {
              if (a.clave > b.clave) return 1;
              if (a.clave < b.clave) return -1;
              return 0;
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .then(() => {
          self.loadEmbalaje = false;
        });
    },
    cargar: function () {
      this.$root.$dialogLoader.show("Espere un momento por favor..");

      var params = {
        uuid_empresa: this.model.uuid_empresa,
      };
      var self = this;
      this.$axios
        .post(this.URL + "list_producto/", params)
        .then((res) => {
          if (typeof res.data !== "undefined" && res.data.length > 0) {
            self.items = res.data.sort((a, b) => a.clave > b.clave);
          } else self.items = [];
        })
        .catch((err) => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener los registros.",
            footer: "",
          });
          console.log(err);
        })
        .then(() => {
          self.$root.$dialogLoader.hide();
        });
    },
    cargar_empresa: async function () {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var params = {
        TableName: "empresas",
        Key: {
          uuid: this.model.uuid_empresa,
        },
      };
      var self = this;
      await this.docClient.get(params, function (err, data) {
        if (err) {
          self.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al cargar los datos de la empresa.",
            footer: "",
          });
        } else {
          if (data.Item != undefined) {
            self.empresa = data.Item;
          }
        }
      });
    },

    get_impuestos: function () {
      if (this.empresa === null) {
        return [];
      }

      let impuestos = [];
      let data = [];

      impuestos = this.empresa.impuestos;
      impuestos.forEach((x) => {
        data.push({
          text: x.tipo + " " + x.tasa,
          value: x,
        });
      });

      return data;
    },
    get_categorias: function () {
      if (this.empresa === null) {
        return [];
      }

      let categorias = [];
      let data = [];
      categorias = this.empresa.tags;
      categorias.forEach((x) => {
        data.push({
          text: x.nombre,
          value: x,
        });
      });

      return data;
    },
    get_precios_venta: function () {
      if (this.empresa === null) {
        return [];
      }

      let precios = [];
      let data = [];
      precios = this.empresa.tipos_precio;
      precios.forEach((x) => {
        data.push({
          text: x.nombre + "-" + x.tasa,
          value: x,
        });
      });

      return data;
    },
    add_precio: function () {
      this.model.precios_venta.push({
        uuid_licencia: this.model.uuid_licencia,
        tipo_precio: "",
        importe: 0,
      });
    },
    remove_precio: function (index) {
      this.model.precios_venta.splice(
        this.model.precios_venta.indexOf(index),
        1
      );
    },
    to_base64: function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    valida_unico: function () {
      let codigo = this.model.codigo;
      let productos = this.items.filter((x) => x.codigo == codigo);

      if (productos.length > 0 && this.updateModel === false) {
        return "El Codigo de Producto ya existe";
      }

      return true;
    },
    agregar: function () {
      this.model = this.clean_model();
      this.updateModel = false;
      this.modal = true;
      this.imagenes = [];
    },
    editar: function (id) {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var self = this;
      this.model = this.clean_model();
      var params = {
        uuid: id,
        uuid_empresa: this.model.uuid_empresa,
      };
      this.$axios
        .post(this.URL + "list_producto/", params)
        .then((res) => {
          if (typeof res.data !== "undefined" && res.data.length > 0) {
            self.model = res.data[0];
            self.search_claves_function(self.model.clave_sat);
            self.search_unidades_function(self.model.unidad_sat);
            self.search_materiales_function(
              self.model.clave_material_peligroso
            );
            self.search_embalajes_function(self.model.embalaje);
            this.modal = true;
            this.updateModel = true;
            this.imagenes = [];
          }
        })
        .catch((err) => {
          this.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener el registro.",
            footer: "",
          });
          console.log(err);
        })
        .then(() => {
          self.$root.$dialogLoader.hide();
        });
    },
    eliminar: function (id) {
      var self = this;
      self
        .$swal({
          type: "info",
          title: "Cuidado",
          text: "¿Está seguro de eliminar el registro?",
          footer: "",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.value) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var data = {
              uuid: id,
            };
            this.$axios
              .post(this.URL + "delete_producto/", data)
              .then((res) => {
                self.$swal({
                  type: "success",
                  title: "¡Operación Exitosa!",
                  text: "El registro se eliminó correctamente.",
                  footer: "",
                });
                self.cargar();
              })
              .catch((err) => {
                this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al eliminar el registro.",
                  footer: "",
                });
                console.log(err);
              })
              .then(() => {
                this.$root.$dialogLoader.hide();
              });
          }
        });
    },
    guardar: async function () {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        for (const imagen of this.imagenes) {
          if (imagen.size > 1024 * 1024) {
            return this.$swal({
              type: "error",
              title: "Error",
              text: "Las imagenes no deben ser mayores a 1Mb.",
              footer: "",
            });
          }
        }
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        var url = this.URL + "create_producto/";
        if (this.updateModel === false) {
          this.model.uuid = this.$uuid.v4();
          await this.prepare_to_save(false);
        } else {
          url = this.URL + "update_producto/";
          await this.prepare_to_save(true);
        }

        var self = this;

        this.$axios
          .post(url, this.model)
          .then((res) => {
            self.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "El registro se guardó correctamente.",
              footer: "",
            });
            self.modal = false;
          })
          .catch((err) => {
            this.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al guardar el registro.",
              footer: "",
            });
            console.log(err);
          })
          .then(() => {
            this.$root.$dialogLoader.hide();
            self.cargar();
          });
      }
    },
    prepare_to_save: async function (update) {
      // Imagenes
      for (const file of this.imagenes) {
        const contents = await this.to_base64(file);
        this.model.imagenes.push({
          file: contents,
        });
      }
    },
    clean_model: function () {
      return {
        uuid: "",
        uuid_empresa: this.$crypto.decrypted(
          this.$local_storage.get(this.$crypto.SHA256("uuid_empresa"))
        ),
        clave: "",
        codigo: "",
        nombre: "",
        categorias: [],
        impuestos: [],
        descripcion: "",
        iva: 0,
        imagenes: [],
        precio_compra: 0,
        precio_venta: 0,
        material_peligroso: "No",
        hidrocarburos: "No",
        tipo_permiso: "",
        sub_producto_hyp: "",
        numero_permiso: "",
        clave_sat: "",
        unidad_sat: "",
        clave_material_peligroso: "",
        pesokg: "",
        tipo_producto: "Concepto",
        objetoImp: "",
      };
    },
  },
};
</script>
